/**
* @ComponentFor Avensia.Shop.Features.Search.Blocks.SearchQuickFilterBlock
*/
import React from 'react';
import classnames from 'classnames';
import * as styles from './components.scss';
import MyMenigoIcon from '../../../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon';
import Icon from 'Shared/Icon';
import { handleQuickFilterClick } from './action-creators';
;
const quickFilterClick = (item, onCustomClick) => {
    if (!!item.disabled)
        return false;
    !!!onCustomClick && handleQuickFilterClick(item, item.selected);
    !!onCustomClick && onCustomClick(item);
};
const formatButtonText = (text) => {
    return text.replace(/_/g, " ");
};
const QuickFilterButton = ({ item, onCustomClick, small }) => (React.createElement("li", { className: styles.searchFilter },
    React.createElement("button", { onClick: () => { quickFilterClick(item, onCustomClick); }, className: classnames(styles.button, { [styles.small]: !!small, [styles.selected]: item.selected, [styles.disabled]: item.disabled }) },
        !!!small && !!item.icon && React.createElement(MyMenigoIcon, { name: item.icon }),
        formatButtonText(item.buttonText),
        " ",
        !!item.selected && React.createElement(Icon, { name: "close" }))));
export default QuickFilterButton;
